import { Component, OnInit } from '@angular/core';
import { BreadcrumbService } from '@app/core/services/breadcrumb.service';
import * as layoutActions from '@app/store/actions/layout.actions';
import * as fromRoot from '@app/store/app.reducer';
import { Store } from '@ngrx/store';
import {
    ErrorInterface,
    InsurancePolicyDataService,
    InsurancePolicyLoadingService,
    InsurancePolicyLoadingStrategyEnum,
    PurchasedProductInterface,
} from 'outshared-lib';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';

@Component({
    selector: 'ins-cancel-container',
    template: `
        <ins-cancel
            [purchasedProducts]="purchasedProducts$ | async">
        </ins-cancel>
    `,
})
export class CancelContainer implements OnInit {

    public purchasedProducts$: Observable<PurchasedProductInterface[]>;
    public loading$: BehaviorSubject<boolean>;
    public subscription: Subscription;

    constructor(
        private insurancePolicyDataService: InsurancePolicyDataService,
        private insurancePolicyLoadingService: InsurancePolicyLoadingService,
        private store$: Store<fromRoot.State>,
    ) {
        this.purchasedProducts$ = this.insurancePolicyDataService.getPurchasedProducts$();
        this.loading$ = new BehaviorSubject(true);
        this.subscription = new Subscription();
    }

    ngOnInit(): void {
        this.setBreadcrumb();
        this.loadPurchasedProducts();
    }

    private setBreadcrumb(): void {
        this.store$.dispatch(new layoutActions.SetBreadcrumb([
            BreadcrumbService.HOME,
            BreadcrumbService.MYZONE,
            {title: 'Opzeggen verzekering'},
        ]));
    }

    private loadPurchasedProducts(): void {
        const getStrategy = this.insurancePolicyLoadingService
            .getStrategy$(InsurancePolicyLoadingStrategyEnum.Default)
            .subscribe({
                next: () => this.onLoadPurchasedProductsSuccess(),
                error: (errors: ErrorInterface[]) => this.onLoadPurchasedProductsError(errors),
            });

        this.subscription.add(getStrategy);
    }

    private selectProduct($event): void {
        // TODO: add panel selection via routing
    }

    private onLoadPurchasedProductsSuccess(): void {
        this.loading$.next(false);
    }

    private onLoadPurchasedProductsError(errors: ErrorInterface[]): void {
        this.loading$.next(false);
        console.error(errors);
    }
}
